import React, { useCallback, useMemo } from 'react';
import './mediaHotspotLine.scss';

const MediaHotspot = ({ media, height, goToScene, handleApartmentPopup }) => {
  const contents = useMemo(() => {
    const res = [];
    const title = media.title || '';
    if (title && title !== '.') {
      res.push(title);
    }
    const description = (media.infoTag?.text || '').split('\n');
    res.push(...description);
    return res;
  }, [media]);

  const imgUrl = useMemo(() => {
    if (media.type === 'Image') {
      return media.imageURL;
    }
    return null;
  }, [media]);

  const isSalesGallery = useMemo(() => media.id === 'sales-gallery', [media]);

  const getContainerHeight = useMemo(() => {
    const heightMap = {
      'TP. Tân An': '110px',
      'KCN Tân Đức': '90px',
      'Water Point Nam Long': '150px',
      'Vinhome Green City': '130px',
      'Aeon Mall Bình Tân': '150px',
      'Bệnh viện Nhi Đồng 2': '110px',
      'Trường ĐH Tân Tạo': '40px',
      LAHOME: '60px',
      'KCN Idico Hựu Thạnh': '90px',
      'CV Võ Văn Tần': '40px',
      'Chợ Cầu Xáng': '50px',
      'Bệnh viện ĐH Y Tân Tạo': '60px',
      'Bến xe Miền Tây': '100px',
    };

    for (const text of contents) {
      if (text && heightMap[text.trim()]) {
        return heightMap[text.trim()];
      }
    }

    if (height) {
      return `${height * 50}px`;
    }

    return '75px';
  }, [contents, height]);

  const onHover = () => {};

  const handleClick = useCallback(() => {
    if (isSalesGallery) {
      // goToScene('can-ho-mau', '2');
      handleApartmentPopup();
    }
  }, [isSalesGallery, handleApartmentPopup]);

  return (
    <div
      className={`khp-media-hotspot ${isSalesGallery ? 'big-bottom' : ''}`}
      onMouseEnter={onHover}
      onClick={handleClick}
    >
      <div
        className="khp-media-hotspot__container"
        style={{ height: getContainerHeight }}
      >
        <div className="khp-media-hotspot__title bcons-text">
          {contents.map((txt, index) => (
            <p key={index} className={contents.length > 2 ? 'text-left' : ''}>
              {txt}
            </p>
          ))}
          {imgUrl && (
            <img
              className="khp-media-hotspot__preview"
              src={imgUrl}
              alt={media.title}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaHotspot;
